import { render, staticRenderFns } from "./PainelAlertas.vue?vue&type=template&id=43d2bb0f&scoped=true"
import script from "./PainelAlertas.vue?vue&type=script&lang=js"
export * from "./PainelAlertas.vue?vue&type=script&lang=js"
import style0 from "./PainelAlertas.vue?vue&type=style&index=0&id=43d2bb0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d2bb0f",
  null
  
)

export default component.exports